// @flow
import fp from "lodash/fp"

import Price from "common/records/Price"
import type { ServicePackage } from "mmb/records/bookingInput"
import type { ServicePackageType } from "mmb/types/servicePackage"

type MapperServicePackage = {
  servicePackageType: ServicePackageType,
  price: Price,
}

export default function(input: ?ServicePackage): ?MapperServicePackage {
  if (!input) {
    return null
  }

  return {
    servicePackageType: fp.get("package_type", input),
    price: new Price({
      amount: parseFloat(fp.get(["price", "amount"], input)),
      base: parseFloat(fp.get(["price", "base"], input)),
      service: parseFloat(fp.get(["price", "service"], input)),
      serviceFlat: parseFloat(fp.get(["price", "service_flat"], input)),
      merchant: parseFloat(fp.get(["price", "merchant"], input)),
      currency: fp.get(["price", "currency"], input),
    }),
  }
}
